import { render, staticRenderFns } from "./newOrderPay.vue?vue&type=template&id=46cf90b5&scoped=true&"
import script from "./newOrderPay.vue?vue&type=script&lang=js&"
export * from "./newOrderPay.vue?vue&type=script&lang=js&"
import style0 from "./newOrderPay.vue?vue&type=style&index=0&id=46cf90b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cf90b5",
  null
  
)

export default component.exports